import { Vehicle } from 'src/store/models/Vehicles'

export interface ResolveProductCardAddToCartParams {
  inCart: boolean
  isSingleCartMode: boolean
  isInterchangeSearch: boolean
  isOnlyTheMiscellaneousCart: boolean
  hasCurrentVehicleEngine: boolean
  isEligibleApplicationPart: boolean
  targetVehicle: Vehicle
  currentVehicle: Vehicle | undefined
  miscellaneousVehicle: Vehicle
  addPartToCart: (vehicle: Vehicle) => Promise<void>
  showDrawer: () => void
}

/**
 * Decides whether to add the part directly to a cart or open the cart selector.
 * Extracted from ProductCard desktop/mobile to keep their cognitive complexity down.
 */
export const resolveProductCardAddToCart = async ({
  inCart,
  isSingleCartMode,
  isInterchangeSearch,
  isOnlyTheMiscellaneousCart,
  hasCurrentVehicleEngine,
  isEligibleApplicationPart,
  targetVehicle,
  currentVehicle,
  miscellaneousVehicle,
  addPartToCart,
  showDrawer,
}: ResolveProductCardAddToCartParams): Promise<void> => {
  if (inCart) return

  if (isSingleCartMode) {
    await addPartToCart(targetVehicle)
    return
  }

  if (isInterchangeSearch) {
    // https://praxent.atlassian.net/browse/BABW-85?focusedCommentId=65782
    if (isOnlyTheMiscellaneousCart && !hasCurrentVehicleEngine) {
      await addPartToCart(miscellaneousVehicle)
      return
    }
    showDrawer()
    return
  }

  if (isEligibleApplicationPart && currentVehicle) {
    await addPartToCart(currentVehicle)
    return
  }

  if (!isOnlyTheMiscellaneousCart) {
    showDrawer()
    return
  }

  await addPartToCart(targetVehicle)
}
